<template>
  <section id="toggles">
    <div class="demo">
      <div class="row">
        <div class="col-md-4">
          <h5>Default</h5>
          <div class="toggle toggle-primary">
            <label>
              <input type="checkbox">
              <span>Default</span>
            </label>
          </div>
          <div class="toggle toggle-primary">
            <label>
              <input type="checkbox" checked="">
              <span>checked</span>
            </label>
          </div>
          <div class="toggle toggle-primary">
            <label>
              <input type="checkbox" disabled="">
              <span>disabled</span>
            </label>
          </div>
          <div class="toggle toggle-primary">
            <label>
              <input type="checkbox" disabled="" checked="">
              <span>disabled checked</span>
            </label>
          </div>
        </div>
        <div class="col-md-4">
          <h5>Medium</h5>
          <div class="toggle toggle-md toggle-success">
            <label>
              <input type="checkbox" checked="">
              <span>medium</span>
            </label>
          </div>
          <div class="toggle toggle-md toggle-primary">
            <label>
              <input type="checkbox" checked="">
              <span>medium</span>
            </label>
          </div>
          <div class="toggle toggle-md toggle-danger">
            <label>
              <input type="checkbox" checked="">
              <span>checked</span>
            </label>
          </div>
        </div>
        <div class="col-md-4">
          <h5>Large</h5>
          <div class="toggle toggle-lg toggle-primary">
            <label>
              <input type="checkbox" checked="">
              <span>large</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/forms/toggles.md";
export default {
  name: "toggles",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.form.toggles.name);
    this.$emit("update-tagline", this.$root.yamlData.form.toggles.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
